import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import PickUpOrderContactInfo from 'components/RwdCheckout/Sections/PickUpOrderContactInfo/Display/PickUpOrderContactInfo';
import PickUpOrderContactInfoEN from 'components/RwdCheckout/Sections/PickUpOrderContactInfo/locales/PickUpOrderContactInfo_en_US.js';
import PickUpOrderContactInfoFR from 'components/RwdCheckout/Sections/PickUpOrderContactInfo/locales/PickUpOrderContactInfo_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(PickUpOrderContactInfoEN, PickUpOrderContactInfoFR);

const localization = createStructuredSelector({
    contactMessage1: getTextFromResource(getText, 'contactMessage1'),
    confirmEmail: getTextFromResource(getText, 'confirmEmail'),
    or: getTextFromResource(getText, 'or'),
    photoId: getTextFromResource(getText, 'photoId'),
    ready: getTextFromResource(getText, 'ready')
});

const fields = createStructuredSelector({
    localization
});

const withPickUpOrderContactInfoProps = wrapHOC(connect(fields, null));

export default withPickUpOrderContactInfoProps(PickUpOrderContactInfo);
